import { render, staticRenderFns } from "./ActionPlansModal.vue?vue&type=template&id=a31b23bc&scoped=true"
import script from "./ActionPlansModal.vue?vue&type=script&lang=ts"
export * from "./ActionPlansModal.vue?vue&type=script&lang=ts"
import style0 from "./ActionPlansModal.vue?vue&type=style&index=0&id=a31b23bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31b23bc",
  null
  
)

export default component.exports